<template>
  <div class="modal_card">
    <div class="modal_form">
      <i @click="$emit('close-modal')" class="icon-close"></i>
      <h1>{{ modalInfo.header }}</h1>
      <form @submit.prevent="submitBranch">
        <b-field
          label="Название филиала:"
          type="is-info"
          :message="errors.first('name')"
          :class="errors.first('name') ? 'error' : ''"
        >
          <b-input
            name="name"
            type="text"
            placeholder="Название филиала"
            v-model="newBranch.name"
            v-validate="{ required: true }"
          ></b-input>
        </b-field>
        <b-field
          label="Адрес:"
          type="is-info"
          :message="errors.first('address')"
          :class="errors.first('address') ? 'error' : ''"
        >
          <b-input
            name="address"
            type="text"
            placeholder="Адрес"
            v-model="newBranch.address"
            v-validate="{ required: true }"
          ></b-input>
        </b-field>
        <b-field
          label="Контакты:"
          type="is-info"
          class="textarea_field"
          :message="errors.first('contact')"
          :class="errors.first('contact') ? 'error' : ''"
        >
          <b-input
            name="contact"
            placeholder="Контакты"
            type="textarea"
            v-model="newBranch.contact"
            v-validate="{ required: true }"
          ></b-input>
        </b-field>
        <button class="add_user_button modal_button left_button" type="submit" :disabled="errors.items.length > 0">
          {{ modalInfo.button }}
        </button>
        <button type="button" @click="$emit('close-modal')" class="close_button modal_button right_button">
          Отмена
        </button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modalInfo: {
      default: () => {},
      type: Object
    },
    newBranch: {
      default: () => {},
      type: Object
    }
  },
  data() {
    return {
      isOpen: true
    }
  },
  created() {
    this.updateDict()
  },
  methods: {
    submitBranch() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit(this.modalInfo.action)
        }
      })
    },
    updateDict() {
      let dict = {
        custom: {}
      }
      dict.custom['name'] = {
        required: 'Поле не заполнено'
      }
      dict.custom['address'] = {
        required: 'Поле не заполнено'
      }
      dict.custom['contact'] = {
        required: 'Поле не заполнено'
      }
      this.$validator.localize('ru', dict)
    }
  }
}
</script>
